(() => {
  const mount = () => {
    const root = document.querySelector('#dd-purchase');
    if (!root || root.dataset.mounted) return;
    root.dataset.mounted = 'true';
    const form = root.querySelector('form');
    const labels = JSON.parse(root.querySelector('[data-commerce-labels]').textContent);
    const quantity = form.elements.quantity;
    const choices = [...form.querySelectorAll('[name="id"]')];
    const price = root.querySelector('.pdp-price');
    const sticky = document.querySelector('.pdp-sticky');
    const buttons = [...document.querySelectorAll('[data-add]')];
    const error = root.querySelector('.dd-purchase-error');
    const currency = root.dataset.currency || 'USD';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    let pack = 1, busy = false;
    const isQuantityPack = root.dataset.quantityPacks === 'true';
    const singleOnlyPromotion = () => document.body.dataset.product === 'perky-lift-firm-breast-cream' && Boolean(window.DDBFCM26?.current());
    const total = (cents, units) => isQuantityPack && !singleOnlyPromotion() ? Math.round(cents * units * (units >= 3 ? .85 : units === 2 ? .9 : 1)) : cents * units;
    const selected = () => choices.find(input => input.checked) || choices[0];
    let packChoices = [];
    const packLegend = root.querySelector('.pdp-packs legend');
    const originalPackLegend = packLegend?.textContent;
    if (isQuantityPack && choices.length === 1) {
      const fieldset = root.querySelector('.pdp-packs');
      choices[0].type = 'hidden';
      const oldLabel = choices[0].closest('label');
      form.append(choices[0]); oldLabel.remove();
      packChoices = [1, 2, 3].map(units => {
        const label = document.createElement('label'), input = document.createElement('input');
        input.type = 'radio'; input.name = 'dd_pack'; input.value = units; input.checked = units === 1;
        input.disabled = choices[0].dataset.available !== 'true';
        const span = document.createElement('span'), title = document.createElement('b'), caption = document.createElement('small');
        title.className='pack-price';title.textContent=money(total(Number(choices[0].dataset.price),units));const name=document.createElement('span');name.className='pack-name';name.textContent=units+labels.packSuffix;
        caption.textContent = units === 2 ? labels.saveTen : units === 3 ? labels.saveFifteen : 'Everyday care';
        span.append(title, name, caption); label.append(input, span); fieldset.append(label);
        input.addEventListener('change', () => { pack = units; sync(); });
        return input;
      });
    }
    const sync = () => {
      const singlesOnly = singleOnlyPromotion();
      if (isQuantityPack && packLegend) packLegend.textContent = singlesOnly ? labels.single : originalPackLegend;
      if (singlesOnly) { pack = 1; packChoices.forEach(input => { input.checked = input.value === "1"; }); }
      const count = Math.max(1, Math.min(Math.floor(99 / pack), Math.floor(Number(quantity.value)) || 1));
      quantity.value = count; quantity.max = Math.floor(99 / pack);
      const variant = selected(), available = variant?.dataset.available === 'true';
      price.textContent = money(total(Number(variant?.dataset.price || 0), count * pack));
      if (sticky) {
        sticky.querySelector('.sticky-price').textContent = price.textContent;
        sticky.querySelector('output').textContent = count;
      }
      buttons.forEach(button => { button.disabled = busy || !available; button.textContent = busy ? labels.adding : available ? labels.add + (sticky?.contains(button) ? ' · '+price.textContent : '') : labels.soldOut; });
      document.querySelectorAll('[data-quantity-step]').forEach(button => {
        button.disabled = busy || (Number(button.dataset.quantityStep) < 0 ? count <= 1 : count >= Number(quantity.max));
      });
      choices.forEach(input => { input.disabled = busy || input.dataset.available !== 'true'; });
      packChoices.forEach(input => {
        const excludedPack = singlesOnly && Number(input.value) > 1;
        input.disabled = busy || !available || excludedPack;
        const label = input.closest("label");
        label.hidden = excludedPack;
        label.style.display = excludedPack ? "none" : "";
        if (input.value === "1") label.querySelector(".pack-name").textContent = singlesOnly ? labels.single : "1" + labels.packSuffix;
      });
      quantity.disabled = busy;
    };
    choices.forEach(input => input.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('variant', input.value); history.replaceState(null, '', url); sync();
    }));
    const applyUrl = () => {
      const variantId = new URL(location.href).searchParams.get('variant');
      const option = choices.find(input => input.value === variantId);
      if (option) choices.forEach(input => { input.checked = input === option; });
      sync();
    };
    addEventListener('popstate', applyUrl);
    document.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
      quantity.value = Number(quantity.value) + Number(button.dataset.quantityStep); sync();
    }));
    quantity.addEventListener('change', sync);
    sticky?.querySelector('[data-add]').addEventListener('click', () => form.requestSubmit());
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      sync();
      if (selected()?.dataset.available !== 'true') return;
      const id = selected().value, units = Number(quantity.value) * pack;
      error.hidden = true; busy = true; sync(); form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root.dataset.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: units }] }) });
        const result = await response.json().catch(() => { throw new Error(labels.error); });
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : labels.error);
        location.assign(root.dataset.cartUrl);
      } catch (problem) {
        error.querySelector('p').textContent = problem instanceof TypeError ? labels.error : problem.message || labels.error;
        error.hidden = false; busy = false; sync(); form.removeAttribute('aria-busy');
        error.setAttribute('tabindex', '-1'); error.focus();
      }
    });
    document.addEventListener('dd:promotion-change', sync);
    addEventListener('pageshow', () => { busy = false; form.removeAttribute('aria-busy'); sync(); });
    applyUrl();
  };
  window.DDCommerce = { mount };
  mount();
  const cartForm = document.querySelector('#dd-cart-form');
  if (cartForm) {
    cartForm.querySelectorAll('[data-cart-step]').forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(0, Math.min(99, Number(input.value) + Number(button.dataset.cartStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }));
    cartForm.addEventListener('change', () => {
      cartForm.querySelector('[data-cart-notice]').hidden = false;
      cartForm.querySelector('[name="checkout"]').disabled = true;
    });
  }
})();
